module.exports = __webpack_public_path__ + "img/sports.68e9ba1c.svg";